<template>

  <div class="col  mt-5">
    <router-view></router-view>
  </div>

</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/cari/_route.vue